module.exports = "https://cdn.realtymogul.com/static/media/icon_learning.f2f073d2.svg";